import React, {Component} from 'react';

import Answer from './Answer'
import DateHandler from './DateHandler'

export default class Question extends Component {

    constructor(props) {
        super(props);

        this.state = {
            pickerVisible: !props.result,
        };
    }

    componentDidMount() {
        const question = this.props.question;

        // if "question" is a result handle it asap
        if (question.type === 'result') {
            this.props.resultHandler(null, question.result, '', '', '', '', '');
        }
    }

    handleAnswerClick = (answer) => {
        this.props.onAnswerClick(answer);
    };

    handleDateChange = (sendDate, printDate) => {
        this.setState({
            pickerVisible: false
        });
        var resultHandler = this.props.resultHandler;
        var question = this.props.question;
        
        var data = {
            "date": sendDate,
            "unit": question.unit,
            "unitValue": question.unitValue,
            "ignoreHolidays": question.ignoreHolidays
        };
        if (question.resultDate2) {
            data.extended = true;
        }
        $.ajax({
            type: 'POST',
            url: '/ajax/calculate',
            data: data,
            success: (response) => {
                if (response.date2 !== undefined) {
                    resultHandler(question.ignoreHolidays, question.result, question.resultDate, response.date, printDate, question.resultDate2, response.date2);
                } else {
                    resultHandler(question.ignoreHolidays, question.result, question.resultDate, response.date, printDate);
                }
            },
            error: () => {
                alert('Dessverre var det en feil, prøv igjen senere');
            }
        });
    };

    infoClicked = () => {
        this.setState({
            pickerVisible: true,
        });
        this.props.onInfoClick(this.props.index - 1);
    };

    render() {
        // answers for this question should only be visible if it is the last in the list and there is no result
        const answersVisible = this.props.isLastQuestion && !this.props.result;

        var answersStyle = {
            display: answersVisible ? 'block' : 'none'
        };

        const hintText = answersVisible ? 'Velg svar nedenfor' : 'Ditt Svar:';

        let selectedAnswerText = '';

        if (this.props.answerText) {
            selectedAnswerText = this.props.answerText;
        }

        // dont render ui if the last "question" is a result (but we still need rest of the question logic to handle the result)
        if (this.props.question.type === 'result') {
            return null;
        }

        return (
            <li className="question-wrapper">
                <div className="question-info" onClick={this.infoClicked}>
                    <div className="index">
                        {this.props.index}
                    </div>
                    <div className="question">
                        {this.props.question.question}
                    </div>
                    <div className="answer">
                        <span className="label">{hintText}</span>
                        <div className="selected-answer-text" dangerouslySetInnerHTML={{__html: selectedAnswerText}}/>
                    </div>
                </div>
                {this.props.question.type === 'question' &&
                <ul className="answer-list" style={answersStyle}>
                    {
                        this.props.question.answers.map((answer, index) => {
                            const indexLetter = String.fromCharCode(97 + index); // gets A, B, C etc.
                            return (
                                <Answer
                                    key={answer.id}
                                    identifier={answer.id}
                                    answer={answer}
                                    onAnswerClick={this.handleAnswerClick}
                                    indexLetter={indexLetter}/>
                            );
                        })
                    }
                </ul>
                }
                {this.props.question.type === 'date' && this.state.pickerVisible ?
                    <DateHandler result={this.props.result}
                                 dateChangeCallback={this.handleDateChange}/>
                    : null}
            </li>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Question.js